// extracted by mini-css-extract-plugin
export default {"ghost-button":"GhostButton_ghost-button__r2UIk"};